/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { AlertItemsListDto, AlertItemDto, AlertDto } from '../api/alerts/alertsClient.typings';
import { updateItemInArray } from '../../utils/utils';
import { AlertsDetailsAction, AlertsDetailsActionType } from '../actions/alertDetailsActions';

export interface AlertsDetailsState {
    alertItems: AlertItemsListDto;
    alertDetails: AlertDto;
    pageSize: number;
    page: number;
    isLoading: boolean;
    updatingItemId: AlertItemDto['id'];
}

const initialState: AlertsDetailsState = {
    alertItems: null,
    alertDetails: null,
    pageSize: 10,
    page: 0,
    isLoading: false,
    updatingItemId: null,
};

export function alertsDetailsReducer(
    state: AlertsDetailsState = initialState,
    action: AlertsDetailsAction,
): AlertsDetailsState {
    switch (action.type) {
        case AlertsDetailsActionType.OPEN_ALERTS_DETAILS_PAGE:
            return {
                ...state,
                alertItems: null,
                alertDetails: null,
                isLoading: true,
            };

        case AlertsDetailsActionType.FETCH_ALERT_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                alertDetails: action.payload,
            };

        case AlertsDetailsActionType.CHANGE_ALERT_ITEMS_PAGE:
            return {
                ...state,
                isLoading: true,
                ...action.payload,
            };

        case AlertsDetailsActionType.FETCH_ALERT_ITEMS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                alertItems: action.payload,
            };

        case AlertsDetailsActionType.UPDATE_ALERT_ITEM_REQ:
            return {
                ...state,
                updatingItemId: action.payload.id,
            };

        case AlertsDetailsActionType.UPDATE_ALERT_ITEM_SUCCESS:
            const items = updateItemInArray(state.alertItems.items, action.payload, 'id');
            return {
                ...state,
                alertItems: {
                    ...state.alertItems,
                    items,
                },
                updatingItemId: null,
            };

        case AlertsDetailsActionType.UPDATE_ALERT_DETAILS:
            return {
                ...state,
                isLoading: true,
            };

        case AlertsDetailsActionType.UPDATE_ALERTS_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                alertDetails: action.payload[0],
            };

        case AlertsDetailsActionType.REPORT_LOAD_START:
            return { ...state, isLoading: true };

        case AlertsDetailsActionType.REPORT_LOAD_FINISH:
            return { ...state, isLoading: false };

        case AlertsDetailsActionType.ALERTS_DETAILS_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case AlertsDetailsActionType.EXIT_ALERTS_DETAILS_PAGE:
            return {
                ...initialState,
            };

        default:
            return state;
    }
}
